var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-divider',{staticClass:"divider"}),_vm._v(" "),_c('v-avatar',{staticClass:"or",attrs:{"size":"40"}},[_vm._v("\n    OR\n  ")]),_vm._v(" "),_c('v-divider',{staticClass:"divider"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }